module.exports = __webpack_public_path__ + "img/android-icon.2cf2ea26.png";